interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  className?: string;
}

export function LoadingSpinner({ size = 'md', message, className = '' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-6 w-6 border-2',
    md: 'h-10 w-10 border-2',
    lg: 'h-14 w-14 border-3',
  };

  const messageClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  return (
    <div className={`flex flex-col items-center justify-center py-8 ${className}`} role="status">
      <div
        className={`animate-spin rounded-full border-gray-400 border-t-transparent ${sizeClasses[size]}`}
        aria-hidden="true"
      />
      {message && (
        <p className={`text-gray-600 mt-4 ${messageClasses[size]}`}>{message}</p>
      )}
      <span className="sr-only">{message || 'Loading...'}</span>
    </div>
  );
}

/**
 * Full page loading state - centers spinner in viewport
 */
export function FullPageLoading({ message = 'Loading...' }: { message?: string }) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <LoadingSpinner size="lg" message={message} />
    </div>
  );
}

/**
 * Section loading state - for loading content within a container
 */
export function SectionLoading({ message }: { message?: string }) {
  return (
    <div className="flex items-center justify-center py-12">
      <LoadingSpinner size="md" message={message} />
    </div>
  );
}

/**
 * Inline loading spinner for buttons and small areas
 */
export function InlineSpinner({ className = '' }: { className?: string }) {
  return (
    <div
      className={`w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin ${className}`}
      aria-hidden="true"
    />
  );
}
